<template>
    
    <div v-if="phase === 'select'" class="entity-form" @click.stop>
        <div class="form-heading">
            <div class="form-title">
                {{ $t('form.multiSelect.select.title') }}{{ selectionLengthInParenthesis }}
            </div>
            <button class="button-primary button-primary__thin" type="button" @click="cancelForm" v-if="!selectedIds.length">{{$t('form.multiSelect.select.cancel')}}</button>
            <button @click="confirmSelection" v-else class="button-primary button-primary__oraange button-primary__thin">{{$t('form.multiSelect.select.next')}}</button>
        </div>

        <div class="flex-column multi-select-page">
           <div class="filter">
                <FormFilter ref="filter"
                    :placeholder="$t('widget.customers.search')"
                    @update="customersUpdated"
                    @update-search-string="searchStringUpdated"
                    @select-all="selectAll"
                    :enable-select-all="!allSelected"
                />
            </div>
            <div class="list">
                <div v-if="orderby" class="custlist-ungrouped" :class="orderby">
                    <CustomerListElement v-for="cust in customers" :key="cust.id"
                        mode="sort-price"
                        :filtered="filtered"
                        :customer="cust"
                        @click="toggleSelection(cust.id)"
                        selectable
                        :selected="selectedIds.includes(cust.id)"
                    />
                </div>
                <template v-else>
                    <div v-for="(custlist, index) in customers" :key="index">
                        <div class="cust-list-alpha-heading">{{custlist[0]}}</div>
                        <CustomerList :customers="custlist[1]" :filtered="filtered" @customer-element-clicked="toggleSelection" selectable :selectedIds="selectedIds"/>
                    </div>
                </template>
                <!-- <div v-else>No results</div> -->
                <!-- // TODO: translation, empty-state component -->
            </div>
        </div>
    </div>



    <div v-else-if="phase === 'action'" class="entity-form" @click.stop>
        <div class="form-heading">
            <div class="form-title">{{ $t('form.multiSelect.actions.title') }}</div>
            <button class="button-primary button-primary__thin" type="button" @click="cancelForm">{{$t('form.multiSelect.actions.cancel')}}</button>
        </div>

        <div class="entity-form-page actions-page">
            <div class="customers">
                <div class="list" @click="toggleCollapseSelectionPreview">
                    <div class="subhead">{{ $t('form.multiSelect.actions.customers', [selectedIds.length]) }}</div>
                    <div class="customer" v-for="(customer,c) in visibleCustomers" :key="`customer-${c}`">
                        <div class="icon"><img src="@/assets/NewCust.svg"/></div>
                        <div class="name">{{customer.firstName}} {{customer.lastName}}</div>
                    </div>
                    <div class="un-collapse" v-if="collapsedItemsCount" @click.stop="unCollapseSelectionPreview">
                        {{ $t('form.multiSelect.collapsed', [String(collapsedItemsCount)])}}
                        <div class="highlighted">{{ $t('form.multiSelect.unCollapse')}}</div>
                    </div>
                </div>
                <div class="controls">
                    <OutlineButton :text=" $t('form.multiSelect.actions.edit')" @click="phase = 'select'"/>
                </div>
            </div>
            <div class="actions">
                <OutlineButton center wide thick :text=" $t('form.multiSelect.actions.actions.message')"
                    @click="()=>{action='message';phase = 'compose';}"/>
                <OutlineButton center wide thick disabled :text="$t('form.multiSelect.actions.actions.party')" />
                <OutlineButton center wide thick disabled :text="$t('form.multiSelect.actions.actions.merge')" />
            </div>
        </div>
    </div>



    <form v-else-if="phase === 'compose'" class="entity-form"  @submit.prevent="sendMessage">
        <div class="form-heading">
            <div class="form-title">{{$t('form.sms.title')}}</div>
            <button class="button-primary button-primary__thin" type="button" @click="cancelForm">{{$t('form.sms.cancel')}}</button>
        </div>
        <div class="entity-form-page message-form-page">
            <div class="customers">
                <div class="list" @click="toggleCollapseSelectionPreview">
                    <div class="subhead">{{ $t('form.sms.receipients', [selectedIds.length]) }}</div>
                    <div class="customer" v-for="(customer,c) in visibleCustomers" :key="`receipient-${c}`">
                        <div class="icon"><img src="@/assets/NewCust.svg"/></div>
                        <div class="name">{{customer.firstName}} {{customer.lastName}}</div>
                    </div>
                    <div class="un-collapse" v-if="collapsedItemsCount" @click.stop="unCollapseSelectionPreview">
                        {{ $t('form.multiSelect.collapsed', [String(collapsedItemsCount)])}}
                        <div class="highlighted">{{ $t('form.multiSelect.unCollapse')}}</div>
                    </div>
                </div>
                <div class="controls">
                    <OutlineButton :text="$t('form.sms.edit')" @click="phase = 'select'"/>
                </div>
            </div>
            <div class="message-form">
                <BaseInput v-model="subject" :label="$t('form.sms.subjectLabel')" :placeholder="$t('form.sms.subjectPlaceholder')" v-if="selectedOption === 'email'"/>
                <BaseTextArea v-model="content" :label="$t('form.sms.messageLabel')" :placeholder="$t('form.sms.messagePlaceholder')" :max-length="selectedOption === 'sms' ? 160 : -1"/>
            </div>
            <div class="message-options">
                <div class="title">{{ $t('form.sms.method.title') }}</div>
                <div class="description">{{ $t('form.sms.method.subtitle') }}</div>
                <div class="options">
                 <!--   <CheckBoxInput v-model="sendOptions.sms" :label="$t('form.sms.method.sms')"/>
                    <CheckBoxInput v-model="sendOptions.email" :label="$t('form.sms.method.email')"/>
               -->

                  <div class="flex flex-row justify-content-between">
                    <input type="radio" :id="'option_sms'" :value="'sms'" v-model="selectedOption" @click="smsOptionSet">
                    <label class="return-reason" :for="'option_sms'">{{$t('form.sms.method.sms')}}</label>
                  </div>
                  <div class="flex flex-row justify-content-between">
                    <input type="radio" :id="'option_email'" :value="'email'" v-model="selectedOption">
                    <label class="return-reason" :for="'option_email'">{{$t('form.sms.method.email')}}</label>
                  </div>

                </div>
                
                <div class="message-controls">
                    <OutlineButton dark wide center thick :text="$t('form.sms.sendBtn')" @click="sendMessage" :disabled="!canSend" :loading="sending"/>
                </div>
            </div>
        </div>
    </form>

</template>

<script>
import OutlineButton from "@/components/core/OutlineButton.vue";
import BaseInput from "@/components/forms/inputs/BaseInput";
import BaseTextArea from "@/components/forms/inputs/BaseTextArea.vue";
import CustomerList from "@/components/lists/CustomerList.vue";
import CustomerListElement from "@/components/lists/elements/CustomerListElement.vue";
//import CheckBoxInput from "@/components/forms/inputs/CheckBoxInput.vue"

import FormFilter from "@/components/forms/filter/FormFilter.vue";
import * as types from '@/store/mutations'
import { nextTick } from 'vue'


    export default {
        name: "SmsForm",
        components: {
            BaseTextArea,
            CustomerList,
            CustomerListElement,
            FormFilter,
            OutlineButton,
            //CheckBoxInput,
            BaseInput
        },
        data() {
            return {
                collapseSize: 5, // click to show all selected customers
                collapsedPreview: true,
                phase: 'select', // select: pick customers | compose: write post and send
                action: null,
                orderby: null,
                filtered: '',
                customers: new Map(),
                selectedIds: [],
                selectedOption:'sms',
                sendOptions: {
                    sms: true,
                    email: false
                },
                sending: false,
                content: '',
                subject: ''
            }
        },
        computed: {
            allSelected(){
                let selected = this.selectedIds
                let selectable = this.customerIds

                let unSelected = selectable.filter(item=>!selected.includes(item))
                if(unSelected.length){
                    return false
                }
                return true
            },
            canSend(){
                if(!this.content.trim()){
                    return false
                }
                if(!this.sendOptions.sms && !this.sendOptions.email){
                    return false
                }
                if(this.sendOptions.email && !this.subject.trim()){
                    return false
                }
                return true
            },
            selectionLengthInParenthesis(){
                return this.selectedIds.length ? ` (${this.selectedIds.length})`: ''
            },
            selectedCustomers(){
                let ids = this.selectedIds
                let all = this.$store.state.customers.customers

                if(!ids.length){
                    return []
                }

                let customers = all.filter(cust=>ids.includes(cust.id))
                customers.sort((a, b) => {
                    return `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`)
                })

                return customers
            },
            customerIds(){
                let customers = this.customers
                let ids = []

                if(Array.isArray(customers)){
                    ids = customers.map(c=>c.id)
                } else {
                    for(let [,subset] of customers){
                        ids.push(...subset.map(c=>c.id))
                    }
                }
                return ids
            },
            visibleCustomers(){
                let all = this.selectedCustomers
                if(!this.collapsedPreview){
                    return all
                }
                return all.slice(0,this.collapseSize)
            },
            collapsedItemsCount(){
                if(!this.collapsedPreview){
                    return 0
                }
                let collapsedCount = this.selectedCustomers.length - this.collapseSize
                if(collapsedCount < 0){
                    return 0
                }
                return collapsedCount
            },
        },
        methods: {
            customersUpdated(customers){
               nextTick(()=>{
                   this.orderby = this.$refs.filter?.orderby
                   this.customers = customers
               })
            },
            smsOptionSet(){
              this.content = this.content.substring(0, 160)
            },
            searchStringUpdated(str){ this.filtered = str },
            toggleSelection(id){
                let locationFound = this.selectedIds.indexOf(id)
                if(locationFound !== -1){
                    this.selectedIds.splice(locationFound,1)
                } else {
                    this.selectedIds.push(id)
                }
            },
            selectAll(){
                let selected = this.selectedIds
                let selectable = this.customerIds
                let uniques = [...new Set([...selected, ...selectable])]
                this.selectedIds = uniques
            },
            confirmSelection(){
                if(this.action){
                    this.phase = 'compose'
                    return
                }
                this.phase = 'action'
            },
            collapseSelectionPreview(){
                console.log("collapseSelectionPreview, was:",this.collapsedPreview);
                this.collapsedPreview = true
            },
            unCollapseSelectionPreview(){
                console.log("unCollapseSelectionPreview, was:",this.collapsedPreview);
                this.collapsedPreview = false
            },
            toggleCollapseSelectionPreview(){
                console.log("toggleCollapseSelectionPreview, was:",this.collapsedPreview);
                this.collapsedPreview = !this.collapsedPreview
            },

            async sendMessage(){
                this.sending = true
                try {
                    let payload = {
                       customerIds: this.selectedIds,
                       content: String(this.content).trim(),
                       subject: String(this.subject).trim(),
                       options: this.selectedOption
                   }
                    await this.$store.dispatch('sendMessageToCustomers', payload)
                    this.$store.commit(types.CLOSE_MESSAGEFORM)
                    this.$store.dispatch('notification', { text: this.$t('form.sms.successMessage') })
                } catch(err) {
                    this.sending = false
                    this.$store.dispatch('notification', { text: this.$t('form.sms.failedMessage'), type: 'error' })
                    console.log("Failed to send SMS",err)
                }
            },
            cancelForm(){
                this.$store.commit(types.CLOSE_MESSAGEFORM)
            }
        },
        mounted(){
            let action = this.$store.state.customers.messages.preSelectedAction
            let customerId = this.$store.state.customers.messages.preSelectedCustomer

            if(customerId){
                this.selectedIds = [customerId]
                this.action = 'message'
                this.phase = 'compose'

                if(action === 'sms'){
                   this.selectedOption = 'sms'
                }
                if(action === 'email'){
                   this.selectedOption = 'email'
                }

            }
            
            this.$store.commit(types.CLEAR_MESSAGES_PRESELECTION)
        }
    }
</script>

<style scoped>
.customers {
    display: flex;
    flex-flow: row;
}
.customers .list {
    flex: 1;
    display: flex;
    flex-flow: column;
    gap: 12px;
}
.customer {
    display: flex;
    flex-flow: row;
}

.customer .icon {
    width: 32px;
}
.customer .icon img {
    display: block;
    width: 24px;
    height: 24px;
}
.customer .name {
    font-family: "Circular Std";
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: #435152;
}
.subhead {
    font-family: "Circular Std";
    font-weight: normal;
    font-size: 12px;
    letter-spacing: 0.04em;
    color: #435152;
    text-transform: uppercase;
}
.actions {
    margin-top: 100px;
    display: flex;
    flex-flow: column;
    gap: 20px;
}

.message-form {
    margin-top: 50px;
    display: flex;
    flex-flow: column;
    gap: 20px;
}
.message-options {
    margin-top: 30px;
}
.message-options .title {
    font-family: "Circular Std";
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
}
.message-options .description {
    font-size: 14px;
    line-height: 21px;
    color: #687374;
}
.message-options .options {
    margin-top: 24px;
    display: flex;
    flex-flow: column;
    gap: 24px;
}
.message-options .options .option {
    display: flex;
    flex-flow: row;
}
.message-controls {
    margin-top: 50px;
    max-width: 334px;
    margin-left: auto;
    margin-right: auto;
}

.multi-select-page,
.actions-page,
.message-form-page {
    padding-bottom: 60px;
    flex: 1;
    overflow-y: auto;
}

.un-collapse {
    margin-top: 5px;
    color: #687374;
    font-size: 14px;
    line-height: 21px;
    display: inline-flex;
    cursor: pointer;
    gap: .5em;
}
.un-collapse:hover {
    color: #2C3536;
}
.un-collapse .highlighted {
    display: inline-block;
    border-bottom: 1px dotted #000;
}
.form-heading {
    z-index: 1;
}
.return-reason {
  padding: 3px;
  margin-left: 5px;
}
</style>
